export const isBanbanHost = window.location.hostname.includes('7banban.com');
export const isChat = window.location.hostname.includes('pati.chat');

const isPaUrl = true;
const helpSite = isChat ? "https://help.pati.chat" : "https://help.pati.sg";
const apiSite = isChat ? "https://api.pati.chat" : "https://api.pati.sg";
export {helpSite, apiSite, isPaUrl};